<template>
  <div class="performance-page">
    <page-header
      :breadcrumbs="breadcrumbs"
    >
      <template v-slot:topbar>
        {{ simulation.name }}
      </template>
    </page-header>
    <div
      class="flex-row big-top-margin"
    >
      <percent-correct :percent="percentCorrect" :total-correct="totalCorrect" :total-incorrect="totalIncorrect" />
      <div
        class="performance-wrapper"
      >
        <data-loader>
          <div class="performance-container">
            <div class="performance-table-header">
              <span>{{ simulation.name }}</span>
              <span class="spacer"></span>
              <icon
                name="calendar"
                class="cal-icon"
                variant="516173"
              ></icon>
              <span>
                Completed {{ completedDate }}
              </span>
            </div>
            <div
              v-for="(tally) in tallies"
              :key="isMultiSectionSimulation ? tally.sectionId : tally.blueprintId"
              class="performance-table-row"
              data-test="performance-table-row"
              tabindex="0"
              @click="goToSection(tally.sectionId, tally.blueprintId)"
            >
              <count-pill
                icon-name="check"
                variant="00b46d"
                start
              >
                <span
                  data-test="performance-table-row-correct"
                >{{ tally.correct }}</span>
              </count-pill>
              <count-pill
                icon-name="cross"
                variant="dc3416"
                end
              >
                <span
                  data-test="performance-table-row-incorrect"
                >{{ tally.incorrect }}</span>
              </count-pill>
              <span class="section-name">{{ tally.sectionName }}</span>
              <span class="spacer"></span>
              <span>
                <icon
                  name="arrow"
                  class="arrow-icon"
                  variant="6ab7da"
                ></icon>
              </span>
            </div>
          </div>
        </data-loader>
      </div>
    </div>
  </div>
</template>

<script>
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import BlueprintMixin from '@/mixins/blueprint';
import PageHeader from '@components/singletons/pageHeader';
import Icon from '@components/singletons/icon';
import DataLoader from '@/components/sims/DataLoader.vue';
import PercentCorrect from '@/components/sims/PercentCorrect.vue';
import CountPill from '@/components/sims/CountPill.vue';

export default {
  components: {
    CountPill,
    PageHeader,
    Icon,
    DataLoader,
    PercentCorrect,
  },
  mixins: [WuxSimulationsMixin, BlueprintMixin],
  computed: {
    breadcrumbs() {
      return [
        {
          name: this.simulation.name,
        },
      ];
    },
    completedDate() {
      const timestamp = this.categoryStatesOrdered[this.categoryStatesOrdered.length - 1].mobileCreatedAt;
      if (!timestamp) return '';

      return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      }).format(new Date(timestamp));
    },
    tallies() {
      if (this.isMultiSectionSimulation) return this.sectionTallies;
      else return this.blueprintTallies;
    },
    totalCorrect() {
      return this.tallies.reduce((acc, tally) => acc + tally.correct, 0);
    },
    totalIncorrect() {
      return this.tallies.reduce((acc, tally) => acc + tally.incorrect, 0);
    },
    percentCorrect() {
      const correct = this.tallies.reduce((acc, tally) => acc + tally.correct, 0);
      const total = this.tallies.reduce((acc, tally) => acc + tally.correct + tally.incorrect, 0);
      if (total === 0) return 0;
      return Math.round((correct / total) * 100);
    },
  },
  methods: {
    goToSection(sectionId, blueprintId) {
      if (this.isMultiSectionSimulation) {
        return this.$router.push({
          name: 'simSection#review',
          params: {
            simId: this.simId,
            sectionId: String(sectionId),
          },
        });
      }

      return this.$router.push({
        name: 'sims#results',
        params: {
          categoryId: this.simId,
          blueprintId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.performance-wrapper {
  width: 100%;
}

.performance-page {
  background: #EDF1F5;
}

.performance-container {
  font-size: 12px;
  font-weight: 600;
  color: #516173;
  background: white;
  background: #FFFFFF;
  border: 1px solid #E0E3E8;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .performance-table-header {
    display: flex;
    padding: 1rem;

    .spacer {
      flex: 1;
    }
  }

  .performance-table-row {
    display: flex;
    padding: 1rem;
    align-items: center;
    border-top: 1px solid rgba(224, 227, 232, 1);
    cursor: pointer;

    .spacer {
      flex: 1;
    }
  }
}

.arrow-icon {
  height: 1rem;
  margin-left: .5rem;
}

.section-name {
  color: black;
  margin-left: 1rem;
}

.flex-row {
  display: flex;
  flex-direction: row;
  gap: 3rem;
}

.big-top-margin {
  margin-top: 7rem;
}

.cal-icon {
  height: 1rem;
  margin-right: .5rem;
}
</style>
